
import { Entity } from '../entity';
import * as Enumerable from 'linq';
import { ProjectStatus } from './project.status';
import { FiltersRelativeDateMethod } from '../../utilities/filters.relative.date.utility';

export interface ProjectViewLookups {

    tags?: Entity[];
    account?: Entity[];
    owner?: Entity[];
    type?: Entity[];
    status?: ProjectStatus[];
}

export interface ProjectViewFilters extends ProjectViewLookups {

    _id?: string;

    total?: number;

    // Multi - Need to check data inside
    search?: string;

    start?: FiltersRelativeDateMethod;
    end?: FiltersRelativeDateMethod;

}

export function effectiveProjectViewFilters(view: ProjectViewFilters, refinements: ProjectViewFilters) {

    const effective: { [k in keyof ProjectViewFilters] } = {} as ProjectViewFilters;
    const keys = Object.keys(new ProjectViewFiltersClass())

    Enumerable.from(keys)
        .forEach(key => {

            const refinement = refinements[key];
            const viewValue = view[key];

            if (Array.isArray(refinement) || Array.isArray(viewValue)) {
                effective[key] = refinement?.length
                    ? refinement
                    : viewValue;
            } else {
                effective[key] = refinement
                    ? refinement
                    : view[key];
            }

            if (effective[key] == null || Object.keys(effective[key])?.length == 0) {
                delete effective[key];
            }
        });

    return effective;

}

export function isProjectViewFiltersRefined(refinements: ProjectViewFilters): boolean {

    if (!refinements) return false;
    if (refinements.search && (refinements.search !== null || refinements.search === '')) return true;

    if (refinements?.account?.length) return true;
    if (refinements?.owner?.length) return true;
    if (refinements?.type?.length) return true;
    if (refinements?.tags?.length) return true;
    if (refinements?.status?.length) return true;

    if (refinements.start) return true;
    if (refinements.end) return true;

    return false;
}


class ProjectViewFiltersClass implements ProjectViewFilters {
    _id = null

    // Multi - Need to check data inside
    search?: string = null;

    // Job Filters
    tags?: Entity[] = [];
    account?: Entity[] = [];
    owner?: Entity[] = [];
    type?: Entity[] = [];
    source?: Entity[] = [];
    status?: ProjectStatus[] = [];

    start?: FiltersRelativeDateMethod = null;
    end?: FiltersRelativeDateMethod = null;
}
